var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "greyed-out", attrs: { id: "expired-screen" } },
    [
      _c(
        "b-row",
        { staticClass: "h-100 justify-content-center align-items-center" },
        [
          _c(
            "b-col",
            { staticClass: "text-center", attrs: { cols: "6" } },
            [
              _c("icon", {
                staticClass: "fa-4x",
                staticStyle: { color: "#777777" },
                attrs: { name: "exclamation-circle" },
              }),
              _vm._v(" "),
              _c("h1", { staticClass: "main-title" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("global.phrases.browserNotSupported")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "description" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("global.phrases.browserNotSupportedDescription")
                    ) +
                    " (" +
                    _vm._s(_vm.browser) +
                    "). " +
                    _vm._s(_vm.$t("global.phrases.listOfRecommendedBrowsers")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    href: "https://www.google.com/intl/es_ALL/chrome/",
                  },
                },
                [
                  _c("icon", {
                    staticClass: "fa-3x p-3",
                    attrs: { name: "chrome" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    href: "https://www.mozilla.org/en-US/firefox/new/",
                  },
                },
                [
                  _c("icon", {
                    staticClass: "fa-3x p-3",
                    attrs: { name: "firefox" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                { attrs: { target: "_blank", href: "https://www.opera.com" } },
                [
                  _c("icon", {
                    staticClass: "fa-3x p-3",
                    attrs: { name: "opera" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }